import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TricaoLogo from 'assets/images/tricao-logo.png';
import { Col, Row, Space } from 'antd';
import Button from 'components/generalUI/Button';
import LanguageSelector from 'components/generalUI/LanguageSelector';
import * as events from 'utils/post-hog/events';
import captureEvent from 'utils/post-hog';
import styles from './NavBar.module.scss';
import NavMenu from './NavMenu';

const NavBar: FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Row justify="center" className={styles.Container} align="middle">
        <Col xs={4} sm={8}>
          <NavMenu />
        </Col>
        <Col xs={10} sm={8} className={styles.LogoContainer}>
          <a href="/">
            <img src={TricaoLogo} alt="Tricao Logo" className={styles.Logo} />
          </a>
        </Col>
        <Col xs={10} sm={8} className={styles.ButtonsContainer}>
          <Space className={styles.Space}>
            <Button
              className={styles.SchedulesAndPricesButton}
              kind="secondary"
              shape="round"
              href="/purchaseChange"
            >
              {t('navigation.navbar.purchaseChange')}
            </Button>
            <Button
              shape="round"
              href="/ticketSelection"
              onClick={() =>
                captureEvent(events.toCalendarButtonClicked, {
                  flow: events.flows.purchase,
                  source: 'navbar',
                })
              }
            >
              {t('navigation.navbar.buyTickets')}
            </Button>
            {/* Hidden below $md — the mobile instance lives in NavMenu's drawer */}
            <LanguageSelector className={styles.LanguageSelector} />
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default NavBar;
